export default {
  link: 'RF',
  modal: 'MW',
  bankImg: 'BB',
  situations: 'LS',
};
